import { defineMessages } from 'react-intl';

import { DiagnocoinLedgerEntryType } from '@/shared/api/protocol-ts/api/billing_new/dto_diagnocoin_new_pb';

import { DiagnocoinHistoryFilter } from './types';

export const filterLabels = defineMessages<DiagnocoinHistoryFilter>({
  [DiagnocoinHistoryFilter.all]: {
    id: 'diagnocoins.history.filter.all',
    defaultMessage: 'All',
  },
  [DiagnocoinHistoryFilter.purchases]: {
    id: 'diagnocoins.history.filter.purchases',
    defaultMessage: 'Purchases',
  },
  [DiagnocoinHistoryFilter.deductions]: {
    id: 'diagnocoins.history.filter.deductions',
    defaultMessage: 'Deductions',
  },
  [DiagnocoinHistoryFilter.refunds]: {
    id: 'diagnocoins.history.filter.refunds',
    defaultMessage: 'Refunds',
  },
});

export const entryTypeLabels = defineMessages<DiagnocoinLedgerEntryType>({
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeInvalidValue]: {
    id: 'diagnocoins.history.type.unknown',
    defaultMessage: 'Balance change',
  },
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeCredit]: {
    id: 'diagnocoins.history.type.credit',
    defaultMessage: 'Coins purchased',
  },
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeReserve]: {
    id: 'diagnocoins.history.type.reserve',
    defaultMessage: 'AI report ordered',
  },
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeCommit]: {
    id: 'diagnocoins.history.type.commit',
    defaultMessage: 'AI report completed',
  },
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeRelease]: {
    id: 'diagnocoins.history.type.release',
    defaultMessage: 'AI report failed — coins returned',
  },
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeReleaseExpired]: {
    id: 'diagnocoins.history.type.releaseExpired',
    defaultMessage: 'AI report failed after the coins had expired',
  },
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeExpire]: {
    id: 'diagnocoins.history.type.expire',
    defaultMessage: 'Coins expired',
  },
  [DiagnocoinLedgerEntryType.DiagnocoinLedgerEntryTypeAdjustment]: {
    id: 'diagnocoins.history.type.adjustment',
    defaultMessage: 'Balance correction',
  },
});
